import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { ROUTE_PATH } from '../../constants';
import OnboardingView from './OnboardingView';
import { OnboardingContactRouteManager } from './contacts/v2/RouteManager';
import { OnboardingSensorRouteManager } from './site-config/v2/sensor/RouteManager';
import { useSelector } from 'react-redux';
import { sessionSelector } from '../../reducers/session';
import { useFetchContactSection } from './hooks/useFetchContactSection';
import { useFetchProducts } from './hooks/useFetchProducts';
import { OnboardingScannerRouteManager } from './site-config/v2/scanner/RouteManager';
import { useFetchAvailableGenericSensors } from './hooks/useFetchAvailableGenericSensors';

const OnboardingRouteManager: React.FunctionComponent = () => {
  useFetchProducts();
  useFetchAvailableGenericSensors();
  useFetchContactSection();

  const canEdit = useSelector(sessionSelector.canEditOnboarding);

  return (
    <Switch>
      {canEdit && (
        <Route
          data-cy="onboarding-contacts-route"
          path={ROUTE_PATH.ONBOARDING.CONTACTS.MAIN}
          component={OnboardingContactRouteManager}
        />
      )}
      {canEdit && (
        <Route
          data-cy="onboarding-sensors-route"
          path={ROUTE_PATH.ONBOARDING.SENSORS.MAIN}
          component={OnboardingSensorRouteManager}
        />
      )}
      {canEdit && (
        <Route
          data-cy="onboarding-scanners-route"
          path={ROUTE_PATH.ONBOARDING.SCANNERS.MAIN}
          component={OnboardingScannerRouteManager}
        />
      )}
      <Route
        exact
        path={ROUTE_PATH.ONBOARDING.MAIN}
        component={OnboardingView}
      />
      <Redirect to={ROUTE_PATH.ONBOARDING.MAIN} />
    </Switch>
  );
};

export default OnboardingRouteManager;
